import axios from "axios";
import { getCookie } from "./useCookie";

let aTokenX = getCookie("access");

let backend = "https://backend.taskilled.com/"
let backendTest = "https://backend-test.taskilled.com/"

axios.defaults.baseURL = backend;
if(aTokenX) {
  axios.defaults.headers.common = {'Authorization': `Bearer ${aTokenX}`};
}

export default axios;